import { HTTP as http } from '../../http'

const PREFIX = '/cart'

export default {
    seItemCart: (data) => {
        return http.post(PREFIX+'/setItem', data)
    },

    addItemsCart: (data) => {
        return http.post(PREFIX+'/addItems', data)
    },

    getItemsCart: () => {
        return http.post(PREFIX+'/getItems')
    },

    updateItemCart: (data) => {
        return http.post(PREFIX+'/updateItem', data)
    },

    removeItemCart: (data) => {
        return http.post(PREFIX+'/removeItem', data)
    },

    destroyCart: (data) => {
        return http.post(PREFIX+'/destroyCart', data)
    },

    applyDiscount: (data) => {
        return http.post(PREFIX+'/apply-discount', data)
    },

    applyDiscountByPayment: (data) => {
        return http.post(PREFIX+'/apply-discount-by-payment', data)
    },

    applyIncreaseByPayment: (data) => {
        return http.post(PREFIX+'/apply-increase-by-payment', data)
    },

    sendClientOrcamento: (data) => {
        return http.post(PREFIX+'/sendClientOrcamento', data)
    },

    removeProductGroup: (body) => {
        return http.post(PREFIX+'/removeProductGroup', body)
    },

    getValidateSupplier: () => {
        return http.post(PREFIX+'/validateSupplier')
    },

}
